import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { Contact } from 'app/models/contact';
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { map, finalize } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Location } from '@angular/common';
import { ContactService } from "app/services/contactService";
import { UserService } from 'app/services/user.service';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { Tag } from 'app/models/tag';
import { TagService } from 'app/services/tag.service';
import { ContactFormComponent } from './contact-form/contact-form.component';
import * as _ from "lodash";
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { ActivatedRoute } from '@angular/router';

enum filterActiveType {
  ALL = 1,
  ACTIVE,
  INACTIVE
}

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit, AfterViewInit {

  filterActiveOptions = [
    { value: filterActiveType.ALL, label: 'Any', selected: true },
    { value: filterActiveType.ACTIVE, label: 'Active Only' },
    { value: filterActiveType.INACTIVE, label: 'Inactive Only' }
  ];
  filterActive: filterActiveType = filterActiveType.ACTIVE;
  filterTags: Tag[] = [];

  contacts: Contact[] = [];
  unfilteredContacts: Contact[] = [];

  tags: Tag[] = [];
  allowedTagsForCreate: Tag[] = [];
  allowedTagsForUpdate: Tag[] = [];

  loadingContactIds: number[] = [];

  tableLoadingIndicator: boolean = true;

  isAddingContact: boolean = false;
  isEditingContact: boolean = false;

  tableLimitSelect: Array<any>;
  selectedTableLimit: number = 5;

  tableCurrentPage = 0;
  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('editModal', { static: true }) editModal: ModalDirective;
  @ViewChild('addModal', { static: true }) addModal: ModalDirective;

  contactsFilter: string = null;

  constructor(public tagService: TagService, private contactService: ContactService, private _validationHandler: ValidationHandler,
    public userService: UserService, private formBuilder: FormBuilder, private ecoDocsTitleService: EcoDocsTitleService,
    private activatedRoute: ActivatedRoute) {

    this.tableLimitSelect = [5, 10, 20, 30, 50, 100];
    this.selectedTableLimit = 5;

  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle( 'Manage Contacts', false );

    this.tableLoadingIndicator = true;
    this.contactService.getAll().subscribe(contacts => {
      this.contacts = contacts;
      this.unfilteredContacts = [...contacts];
      setTimeout(() => { this.tableLoadingIndicator = false; }, 100);
      this.updateFilter();
    });

    this.tagService.currentTagsSubject.subscribe((t) => {
      this.tags = t; 
      this.allowedTagsForCreate = [];
      this.allowedTagsForUpdate = [];
      
      if (this.userService.getPermissions('super.admin.contacts.create').all) {
        this.allowedTagsForCreate = t;
      } else if (this.userService.getPermissions('super.admin.contacts.create').tags) {
        this.allowedTagsForCreate = _.intersectionBy(t, this.userService.getPermissions('super.admin.contacts.create').tags, 'id');
      }

      if (this.userService.getPermissions('super.admin.contacts.create.update').all) {
        this.allowedTagsForUpdate = t;
      } else if (this.userService.getPermissions('super.admin.contacts.create.update').tags) {
        this.allowedTagsForUpdate = _.intersectionBy(t, this.userService.getPermissions('super.admin.contacts.create.update').tags, 'id');
      }
    });
  }

  
  ngAfterViewInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      const search: string = queryParams['search']? queryParams['search']: '';
  
      if (search.length > 0) {
        setTimeout(() => {
          this.contactsFilter = search;
          this.updateFilter();            
        }, 1);
      }
    });    
  }

  innerWidth() {
    return window.innerWidth;
  }
  onAddContact(contactForm: ContactFormComponent) {
    if(!contactForm.getFormGroup().valid)
    {
      this._validationHandler.onSubmitCheck(contactForm.getFormGroup());
      return ;
    }
    this.isAddingContact = true;

    let contact: Contact = contactForm.getValue();

    this.contactService.put(contact).pipe(finalize(() => {
      this.isAddingContact = false;
      this.addModal.hide();
    })).subscribe(c => {
      this.unfilteredContacts.unshift(c);
      // re-apply filter
      this.updateFilter();

      // refresh data
      this.contacts = [...this.contacts];
      contactForm.currentContact = null;
    }, err => {
      /** @todo handle error */
      
      this._validationHandler.serverValidationHandler(err, contactForm.getFormGroup());

    });
  }
  
  
  onEditContactSubmit(contactForm: ContactFormComponent) {
    if (!contactForm.getFormGroup().valid) {
      this._validationHandler.onSubmitCheck(contactForm.getFormGroup());
      return;
    }
    this.isEditingContact = true;

    let contact: Contact = contactForm.getValue();

    this.contactService.put(contact).pipe(finalize(() => {
      this.isEditingContact = false;
      contactForm.currentContact = null;
    })).subscribe((c: any) => {
      // refresh data

      var contactIndex = this.unfilteredContacts.findIndex((v, i, o) => {
        return v.id == c.id;
      });

      if (contactIndex != -1)
        this.unfilteredContacts[contactIndex] = c;

      this.updateFilter();
      this.contacts = [...this.contacts];

      // redirect to the same table page
      this.table.bodyComponent.offset = this.tableCurrentPage;
      this.table.offset = this.tableCurrentPage;

      this.editModal.hide();
      this.isEditingContact = false;
      contactForm.currentContact = null;
    }, err => {
      /** @todo handle error */
      // console.log(err)
      this._validationHandler.serverValidationHandler(err, contactForm.getFormGroup());

      this.isEditingContact = false;
    });
  }


  onEditContact(contact: Contact, contactForm: ContactFormComponent) {
    this.tableCurrentPage = this.table.offset;

    // edit contact form 
    contactForm.currentContact = contact;

    this.editModal.show();
  }

  onCloseEdit(contactForm: ContactFormComponent) {
    this.editModal.hide();
    contactForm.currentContact = null;
    this.isEditingContact = false;
  }

  onActivateChanged(event, contact) {
    if (event.target.checked) {
      if (!this.loadingContactIds.includes(contact.id)) {
        this.contactService.restore(contact).pipe(map(x => {
          /** @todo handle error */
          contact.deleted_at = null;
          this.loadingContactIds = this.loadingContactIds.filter(id => id != contact.id);
          this.contacts = [...this.contacts];
        })).subscribe();
        this.loadingContactIds.push(contact.id);
      }
    } else {
      if (!this.loadingContactIds.includes(contact.id)) {
        this.contactService.deactivate(contact).subscribe(x => {
          /** @todo handle error */
          contact.deleted_at = Date.now();
          this.loadingContactIds = this.loadingContactIds.filter(id => id != contact.id);
          this.contacts = [...this.contacts];
        });
        this.loadingContactIds.push(contact.id);
      }
    }
  }
  updateFilter() {
    const val = (this.contactsFilter) ? this.contactsFilter.toLowerCase() : null;

    // filter our data
    const temp = this.unfilteredContacts.filter((contact) => {

      return (contact.name.toLowerCase().indexOf(val) !== -1 || contact.email.toLowerCase().indexOf(val) !== -1 || !val) &&
        (this.filterActive == filterActiveType.ALL || (this.filterActive == filterActiveType.ACTIVE && !contact.deleted_at)
          || (this.filterActive == filterActiveType.INACTIVE && contact.deleted_at)) &&
        (this.filterTags.length == 0 || _.intersectionWith(this.filterTags, contact.tags, (a, b)=>{return a.name == b.name}).length > 0);
    });

    // update the rows
    this.contacts = temp;

    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }


}
